import "./Cursadas.css"
import NavCursada from "./Nav/NavCursada.jsx";
import { useState, useEffect } from "react";


import Inicio from './Inicio/Inicio.jsx';
import Modulos from './Modulos/Modulos.jsx';
import Activity from './Activity/Activity.jsx';
import Calificaciones from "./Calificaciones/Calificaciones.jsx"


import { getCourseById } from '../../../Services/Courses.js';
import { getInfoByUsrId } from '../../../Services/User.js'

export default function Cursada (props) {

    const [subFrame, setSubFrame] = useState('inicio');
    const [courseInfo, setCourseInfo] = useState(false);
    const [activitiesId, setActivitiesId] = useState([]);
    const [isFinished, setIsFinished] = useState(false);


    const loadCourseInfo = async () => {
        let rsp = await getCourseById(props.idCursada);


        if(rsp?.Error == false){
            
            let teacherRsp = await getInfoByUsrId(rsp.Data.id_teacher);
            
            
            if(teacherRsp.Error == false){
                setCourseInfo({...rsp.Data, teacher:teacherRsp.Data[0]});
            }

        }
    }
    
    


    var frame;
    switch(subFrame){
        case 'inicio':{
            frame = <Inicio courseInfo={courseInfo}/>
            break;
        }
        case 'modulos':{
            frame = <Modulos courseInfo={courseInfo} setSubFrame={setSubFrame} setActivitiesId={setActivitiesId} setIsFinished={setIsFinished}/>
            break;
        }
        case 'activity':{
            frame = <Activity activitiesId={activitiesId} setSidebarState={props.setSidebarState} isFinished={isFinished} courseInfo={courseInfo} setSubFrame={setSubFrame} lectureId={1}/>
            break;
        }
        case 'calificaciones':{
            frame = <Calificaciones courseInfo={courseInfo}/>
            break;
        }
    }

    useEffect(() => {
        loadCourseInfo();
    }, []);

    return (
        <div>
            <div>
            <NavCursada setSubFrame={setSubFrame} subFrame={subFrame} />
            </div>
            <div>
                {frame}
            </div>
        </div>


    );
}


